import { createContext, useContext } from 'react';

import { DialogProps } from '@material-ui/core';

export interface Context {
  id: string;
  open: boolean;
  static: boolean;
  onOpen: () => void;
  onClose: () => void;
  props: Omit<DialogProps, 'open' | 'onClose'>;
  isLoading: boolean;
}

export const DialogContext = createContext<Context>({
  id: '--dialog-composite-context-id--',
  open: false,
  static: false,
  onOpen: () => {},
  onClose: () => {},
  props: {},
  isLoading: false,
});

export const useDialogContext = () => {
  return useContext(DialogContext);
};
